// ../components/NotFoundEmployeesPopup.jsx


// import React from "react";
// import { Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, Button } from "@mui/material";

// const NotFoundEmployeesPopup = ({ openNotFoundPopup, setOpenNotFoundPopup, notFoundEmployeeCodes }) => {
//   return (
//     <Dialog open={openNotFoundPopup} onClose={() => setOpenNotFoundPopup(false)} maxWidth="sm" fullWidth>
//       <DialogTitle>Not Found Employees</DialogTitle>
//       <DialogContent>
//         <List>
//           {notFoundEmployeeCodes?.map((code, index) => (
//             <ListItem key={index}>
//               <ListItemText primary={code} />
//             </ListItem>
//           ))}
//         </List>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={() => setOpenNotFoundPopup(false)} variant="contained">
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default NotFoundEmployeesPopup;

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const NotFoundEmployeesPopup = ({
  openNotFoundPopup,
  setOpenNotFoundPopup,
}) => {
  return (
    <Dialog
      open={openNotFoundPopup}
      onClose={() => setOpenNotFoundPopup(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 600, position: "relative" }}>
        Invalid Employee Codes

        <IconButton
          onClick={() => setOpenNotFoundPopup(false)}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          textAlign: "center",
          py: 6,
          borderTop: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="body1">
          Some employee codes could not be processed because they are invalid or not associated with the selected plant.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          py: 3,
        }}
      >
        <Button
          onClick={() => setOpenNotFoundPopup(false)}
          sx={{
            minWidth: "72px",
            height: "58px",
            borderRadius: "10px",
            border: "2px solid #32CD32",
            color: "#000",
            backgroundColor: "#fff",
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#fff",
              border: "2px solid #32CD32",
              boxShadow: "none",
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotFoundEmployeesPopup;
